export default Object.freeze({
  SEARCH_DATA_TYPE_STATE_CHANGE_YMDT: '주문접수일시',
  SEARCH_DATA_TYPE_ORDER_YMDT: '주문일시',
  MEMBER_GROUP_PUPOP_TITLE: '회원그룹 상세',
  TABLE_TITEL: '조회결과 주문 건수',
});
